import { getWebInstrumentations, initializeFaro, faro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { APP_VERSION } from '@/version';

let initialized = false;

export function initFaro() {
    const collectorUrl = import.meta.env?.VITE_FARO_COLLECTOR_URL;
    if (!collectorUrl || initialized) return;

    const environment = import.meta.env?.MODE === 'development' ? 'local' : 'production';

    initializeFaro({
        url: collectorUrl,
        app: {
            name: 'debtbound-frontend',
            version: APP_VERSION,
            environment,
        },
        instrumentations: [
            ...getWebInstrumentations({
                captureConsole: true,
                captureConsoleDisabledLevels: [],
            }),
            new TracingInstrumentation(),
        ],
        sessionTracking: {
            enabled: true,
            persistent: true,
        },
    });

    initialized = true;
}

export function captureException(error: unknown) {
    if (!initialized) return;
    if (error instanceof Error) {
        faro.api.pushError(error);
    } else {
        faro.api.pushError(new Error(String(error)));
    }
}

export function setUser(userId: string, properties: Record<string, string>) {
    if (!initialized) return;
    faro.api.setUser({
        id: userId,
        email: properties.email,
        username: properties.name,
        attributes: properties,
    });
}

export function resetUser() {
    if (!initialized) return;
    faro.api.resetUser();
}

export function trackEvent(name: string, properties?: Record<string, unknown>) {
    if (!initialized) return;
    const attributes: Record<string, string> = {};
    if (properties) {
        for (const [key, value] of Object.entries(properties)) {
            attributes[key] = String(value);
        }
    }
    faro.api.pushEvent(name, attributes);
}

export function trackPageView(path: string) {
    if (!initialized) return;
    faro.api.pushEvent('page_view', {
        path,
        url: window.location.href,
    });
}

export { faro };
